import { Filters } from '@type/main'

export const getEmptyFilters = (): Filters => {
  const emptyFilters: Filters = {
    price: {
      min: 0,
      max: 1300,
    },
    rating: 0,
    duration: {
      min: 0,
      max: 100 * 60 * 60,
    },
    category: [],
    subCategory: [],
    topic: [],
    language: [],
    level: [],
  }

  return emptyFilters
}
